import { Injectable } from "@angular/core";
import { Http, Response } from "@angular/http";
import { Observable } from "rxjs/Observable";
import { ISystemStatus } from "./system-status";
import { ISystemInfo } from "./system-info";
import { ISystemLastHeartbeat } from "./system-last-heart-beat";
import { ISystemRecentPoints } from "./system-recent-points";
import { ISystemPointHistory } from "./system-point-history";
import "rxjs/add/operator/map";
import "rxjs/add/operator/do";
import "rxjs/add/operator/catch";
import { AdalHttp } from '../../services/adal.http.service';

@Injectable()
export class SystemHealthRetriever {
    constructor(private http: AdalHttp) {
    }

    getlastheartbeatByGuid(systemGuid: string, tenant: string): Observable<any> {
        let productUrl: string = `/api/tenants/${tenant}/systems/${systemGuid}/systemheartbeat/last`;
        return this.http.get(productUrl)
            .catch((error: any) => {
                return Observable.throw(error || 'server error');
            });

    }
    getsysteminformationByGuid(systemGuid: string, tenant: string): Observable<any> {
        let productUrl: string = `api/tenants/${tenant}/systems/${systemGuid}/systeminfo/last`;
        return this.http.get(productUrl)
            .catch((error: any) => {
                return Observable.throw(error || 'server error');
            });

    }
    getsystemonlinestatusByGuid(systemGuid: string,tenant: string): Observable<any> {
        let productUrl: string = `/api/tenants/${tenant}/systems/${systemGuid}/systemstatus/last`;
        return this.http.get(productUrl)
            .catch((error: any) => {
                return Observable.throw(error || 'server error');
            });

    }
    getrecentpointsByGuid(systemGuid: string, tenant: string): Observable<any> {
        let productUrl: string = `/api/tenants/${tenant}/systems/${systemGuid}/points/recent`;
        return this.http.get(productUrl)
            .catch((error: any) => {
                return Observable.throw(error || 'server error');
            });
    }
    getpointhistoryByGuid(systemGuid: string, tenant: string): Observable<any> {
        let productUrl: string = `/api/tenants/${tenant}/systems/${systemGuid}/points/range`;
        return this.http.get(productUrl)
            .catch((error: any) => {
                return Observable.throw(error || 'server error');
            });
    }

}


/** WEBPACK FOOTER **
 ** ./F:/actions-runner/_work/scpbuildinig_sentience.portal.devops/scpbuildinig_sentience.portal.devops/src/Production/Portal/Cloud.Platform.Global.Portal.DevOps.Web/app/main/systemHealthRetriever/system-health-retriever.service.ts
 **/